import React, { useState, useEffect } from "react";
import { Button, Divider, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import axios from "axios"
import { Auth } from "aws-amplify";
import { CSVLink } from "react-csv";
import { useTranslation } from "react-i18next";

import FilterListIcon from '@mui/icons-material/FilterList';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import GroupAddIcon from '@mui/icons-material/GroupAdd';

import Table from "../../TableComponent";
import AddOrganizationWizard from "./AddOrganizationWizard";

const Organizations = ({masterAdminInfo}) => {
  const [loading, setLoading] = useState(true)
  const [orgsData, setOrgsData] = useState([])
  const [region, setRegion] = useState("");
  const [page, setPage] = useState({
    mode: "",
    orgData: null,
  });

  const { t } = useTranslation();
  
  useEffect(() => {
    Auth.currentSession()
    .then((data) => {
      const jwtToken = data.idToken.jwtToken;
      
      const getOrgsData = async(masterAdminId) => {
        try {
          const response =  await axios.get("https://zk1128nq2f.execute-api.ap-south-1.amazonaws.com/alpha/masterAdmin/"+masterAdminId+"/orgs", {
              headers: {
                  'Content-Type': 'application/json',
                  'Authorization': jwtToken
              }
          });
          // console.log("Orgs Data: ",response.data)
          setOrgsData(response.data["orgs"])
          setLoading(false)
        }
        catch (error) {
          console.log(error)
          setLoading(false)
        }
      }
      getOrgsData(masterAdminInfo.masterAdmin.masterAdminId)
      
    })
    .catch((err) => console.log(err));
    
  }, [masterAdminInfo]);

  const handleOptionButtonClick = (option, orgData) => {
    switch (option) {

      case "Edit Admin and Class":
        setPage({
          mode: "editAdminAndClass",
          orgData,
        });
        break;

      case "Edit Stories":
        setPage({
          mode: "editStories",
          orgData,
        });
        break;

      default:
        break;
    }
  }
  
  const columns = [
    { 
      key: "superAdminId", 
      headerName: t("commonItems.tableHeader_superAdminId"), 
      width: 40 
    },
    { 
      key: "org", 
      headerName: t("commonItems.tableHeader_prefix"), 
      width: 40 
    },
    { 
      key: "name", 
      headerName: t("commonItems.tableHeader_name"), 
      width: 120 
    },
    {
      key: "region",
      headerName: t("commonItems.tableHeader_region"),
      width: 60
    },
    {
      key: "city",
      headerName: t("commonItems.tableHeader_city"),
      width: 60
    },
    {
      key: "adminCount",
      headerName: t("commonItems.tableHeader_adminCount"),
      width: 40
    },
    { 
      key: "options", 
      headerName: "", 
      width: 30,
      options: "orgs",
      handleClick: handleOptionButtonClick 
    }
  ];

  const headers = [
    { label: "Super Admin Id", key: "superAdminId" },
    { label: "Prefix", key: "org" },
    { label: "Name", key: "name" },
    { label: "Region", key: "region" },
    { label: "City", key: "city" },
    { label: "Admin Count", key: "adminCount" }
  ];
  
  const handleRegionChange = (e) => {
    setRegion(e.target.value);
  };
  
  var filteredOrgsData
  if(region===""){
    filteredOrgsData = orgsData
  }
  else filteredOrgsData = [...orgsData.filter(item => item.region === region)]

  return (
    <div className="innerContent">
      {page.mode === "" &&
        <>
          <h2 style={{textAlign: "center", color: "#0288D1", borderRadius: "15px", border: "1px solid"}}>
            {t("masterAdmin.organizations.title")}
          </h2>
          <div className="filters">
            <div className="forms">
              <h4 style={{display: "flex", justifyContent: "center", alignItems: "center", gap: "0.25rem"}}>
                <FilterListIcon fontSize="small"/>
                <span style={{height: "100%"}}>{t("commonItems.filterLabel")}</span> 
              </h4>
              <FormControl sx={{ m: 1, minWidth: 150}} size="small">
                <InputLabel id="regionFilterLabel">{t("commonItems.dropdownLabel_region")}</InputLabel>
                <Select
                  labelId="regionFilterLabel"
                  id="regionFilter"
                  value={region}
                  onChange={handleRegionChange}
                  autoWidth
                  label={t("commonItems.dropdownLabel_region")}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {/* getting all unique region values from data */}
                  {[...new Set(orgsData.map(item => item.region))].sort().map((item, i) => {
                    return <MenuItem key={i} value={item}>{item}</MenuItem>
                  })}
                </Select>
              </FormControl>
            </div>
          </div>
          <div className="tabs">
            <Button variant="contained" color="info" startIcon={<FileDownloadIcon />} sx={{ placeSelf: "start" }}>
              <CSVLink 
                data={filteredOrgsData} 
                headers={headers} 
                filename={(region ? region : "All") + "-orgsData.csv"}
              >
                {t("commonItems.buttonLabel_csvDownload")}
              </CSVLink>
            </Button>
            <Button variant="contained" color="info" startIcon={<GroupAddIcon />} onClick={() => setPage({mode: "create", orgData: null})}>
              Add Org
            </Button>
          </div>
          <Divider />
          <div className="table">
            <Table
              columns={columns}
              tableData={filteredOrgsData}
              orderBy={["superAdminId", "name"]} 
              tableHeight="calc(100vh - 318px)"
              loading={loading}
            />
          </div>
        </>
      }
      {page.mode === "create" && 
        <AddOrganizationWizard mode="create" masterAdminInfo={masterAdminInfo} orgsData={orgsData} setPage={setPage} />
      }
      {page.mode === "editAdminAndClass" && (
        <AddOrganizationWizard
          mode="editAdminAndClass"
          masterAdminInfo={masterAdminInfo}
          orgsData={page.orgData}
          setPage={setPage}
        />
      )}
      {page.mode === "editStories" && (
        <AddOrganizationWizard
          mode="editStories"
          masterAdminInfo={masterAdminInfo}
          orgsData={page.orgData}
          setPage={setPage}
        />
      )}
    </div>
  );
};

export default Organizations;
